var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 804.52 313.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #333;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #d13536;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M690.75,83.95c-62.82,0-113.74,50.92-113.74,113.74s50.92,113.77,113.74,113.77,113.77-50.95,113.77-113.77-50.95-113.74-113.77-113.74ZM690.75,255.23c-32.54,0-58.93-26.39-58.93-58.96s26.39-58.96,58.93-58.96,58.96,26.39,58.96,58.96-26.39,58.96-58.96,58.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M553.82,140.79v100.95c0,.05.03.13.05.26-.05.26-.05.55-.05.84,0,2.36.53,4.6,1.5,6.59.66,1.42,1.55,2.73,2.63,3.86-.03.03,0,.03.05.05,1.97,3.05,5.25,4.39,9.01,4.91.74.11,1.47.18,2.23.21,5.52.39,11.63-.47,16.02-.08v49.98c-5.62,4.6-18.96,3.57-26.5,2.92-45.36-3.97-57.67-29.02-61.8-62.61v-115.61c.03-4.91.03-9.8,0-14.71-.05-25.87-.37-51.74-.16-77.55l57.02,1.97v49.01h65.68c-18.25,11.9-32.88,28.91-41.81,49.01h-23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.36,305.43h-55.03v-126.43c0-8.16-13.15-24.11-19.82-29.23-39.72-30.5-94.67-.75-93.62,48.29,1.13,53.03,65.07,75.71,101.66,38.77v64.68c-88.19,32.59-168.16-43.65-148.82-133.73,18.21-84.78,129.85-108.29,188.11-47.57,9.71,10.12,27.53,43.33,27.53,56.83v128.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.35,
    y: 107.46,
    width: 55.03,
    height: 199.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M483.07,93.76v151.9c0,1.81-6.12,18.94-7.51,21.9-26.66,57.3-107.49,59.96-145.76,13.34-8.17-9.98-21.64-34.38-21.64-47.01V93.76h55.02v128.48c0,10.74,4.23,20.54,11.08,27.76,1.6,1.68,3.34,3.2,5.2,4.6v.24c.66.42,1.34.81,2.02,1.16,2.34,1.55,4.83,2.84,7.48,3.83,4.49,1.76,9.38,2.71,14.5,2.71,20.33,0,37.16-15.07,39.89-34.67.24-.95.39-1.63.39-1.79V93.76h39.31Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 40.86,
    cy: 40.86,
    r: 40.86
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.847bd5071d362c694807c2c4b674b6c2.svg";
export { ForwardRef as ReactComponent };